function DiscountsIcon({ white = false }: { white?: boolean }) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_2200_12991)">
				<path
					d="M12.002 23.0626C10.874 23.0626 9.83914 22.5397 9.16283 21.6279C8.77508 21.1051 8.15534 20.793 7.50505 20.793C7.40417 20.793 7.30227 20.8005 7.20228 20.8154C7.02795 20.8413 6.85034 20.8544 6.67438 20.8544C5.73102 20.8544 4.84503 20.4879 4.17959 19.8225C3.38183 19.0247 3.01991 17.923 3.18659 16.7998C3.29853 16.0453 2.98719 15.2941 2.37411 14.8393C1.46234 14.163 0.939453 13.1281 0.939453 12.0001C0.939453 10.8721 1.46239 9.83726 2.37416 9.16095C2.98733 8.70612 3.29867 7.9549 3.18669 7.2004C3.01995 6.07718 3.38188 4.97543 4.17959 4.17772C4.84508 3.51228 5.73111 3.14581 6.67442 3.14581C6.85039 3.14581 7.02795 3.15893 7.20228 3.18481C7.30203 3.19962 7.40366 3.20712 7.50434 3.20712C8.15511 3.20712 8.77508 2.89503 9.16283 2.37237C9.83909 1.46056 10.874 0.937622 12.002 0.937622C13.13 0.937622 14.1648 1.46056 14.8411 2.37228C15.2289 2.89503 15.8486 3.20712 16.4989 3.20712C16.5998 3.20712 16.7016 3.19958 16.8016 3.18476C16.976 3.15889 17.1535 3.14576 17.3295 3.14576C18.2728 3.14576 19.1588 3.51223 19.8243 4.17772C20.622 4.97543 20.9839 6.07714 20.8172 7.2004C20.7052 7.9549 21.0166 8.70612 21.6298 9.16095C22.5415 9.83726 23.0645 10.8721 23.0645 12.0001C23.0645 13.1281 22.5416 14.163 21.6298 14.8393C21.0167 15.2941 20.7054 16.0453 20.8173 16.7998C20.984 17.923 20.6221 19.0247 19.8243 19.8224C19.1589 20.4879 18.2729 20.8544 17.3297 20.8544C17.3296 20.8544 17.3296 20.8544 17.3295 20.8544C17.1535 20.8544 16.9759 20.8413 16.8016 20.8154C16.7019 20.8006 16.6003 20.7931 16.4996 20.7931C15.8488 20.7931 15.2288 21.1052 14.8411 21.6279C14.1648 22.5397 13.1299 23.0626 12.002 23.0626Z"
					stroke={white ? "white" : "#4D5561"}
					strokeWidth="1.5"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<circle
					cx="9.1875"
					cy="9.18762"
					r="0.9375"
					fill={white ? "white" : "#4D5561"}
				/>
				<circle
					cx="14.8145"
					cy="14.8125"
					r="0.9375"
					fill={white ? "white" : "#4D5561"}
				/>
				<path
					d="M14.8125 9.1875L9.1875 14.8125"
					stroke={white ? "white" : "#4D5561"}
					strokeWidth="1.5"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2200_12991">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default DiscountsIcon;
